import { useEffect, useState } from "react";

export const useDebounce = (value, delay) => {
  const [searchText, setSearchText] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return searchText;
};

export default useDebounce;
